import type { MaskAdapter, MaskPreset } from "../types";
import { CurrencyPresetAdapter } from "./currency-preset-adapter";
import { DocumentPresetAdapter } from "./document-preset-adapter";
import { GenericMaskAdapter } from "./generic-mask-adapter";
import { NumberPresetAdapter } from "./number-preset-adapter";
import { PercentagePresetAdapter } from "./percentage-preset-adapter";
import { PhonePresetAdapter } from "./phone-preset-adapter";
import { QuantityPresetAdapter } from "./quantity-preset-adapter";
import { WeightPresetAdapter } from "./weight-preset-adapter";
import { ZipcodePresetAdapter } from "./zipcode-preset-adapter";

/**
 * Factory function to create appropriate adapter based on preset or mask pattern
 */
export function createMaskAdapter(preset?: MaskPreset, mask?: string): MaskAdapter {
  if (preset) {
    switch (preset) {
      case "currency":
        return new CurrencyPresetAdapter();
      case "number":
        return new NumberPresetAdapter();
      case "percentage":
        return new PercentagePresetAdapter();
      case "weight":
        return new WeightPresetAdapter();
      case "quantity":
        return new QuantityPresetAdapter();
      case "cnpj":
      case "cpf":
        return new DocumentPresetAdapter(preset);
      case "phone":
      case "phone-with-country":
        return new PhonePresetAdapter(preset);
      case "zipcode":
        return new ZipcodePresetAdapter();
      default:
        throw new Error(`Unknown preset: ${preset}`);
    }
  }

  if (mask) {
    return new GenericMaskAdapter(mask);
  }

  // Fallback to a generic adapter with no mask (pass-through)
  return new GenericMaskAdapter("");
}

// Export all adapters for potential direct use
export {
  CurrencyPresetAdapter,
  DocumentPresetAdapter,
  GenericMaskAdapter,
  NumberPresetAdapter,
  PercentagePresetAdapter,
  PhonePresetAdapter,
  QuantityPresetAdapter,
  WeightPresetAdapter,
  ZipcodePresetAdapter,
};
